import React from "react";

function ContactDetails() {
  const contactInfo = [
    {
      icon: "fas fa-map-marker-alt",
      title: "Our Location",
      details: ["302, City Height Prime, Bhavnagar"],
      color: "#673AB7",
    },
    {
      icon: "fas fa-phone-alt",
      title: "Phone Number",
      details: ["+91 7383847632"],
      color: "#2196F3",
    },
    {
      icon: "fas fa-envelope",
      title: "Email Address",
      details: ["sales@xeertechnology.com"],
      color: "#f43f5e",
    },
  ];

  return (
    <div className="contact-details-area py-5">
      <div className="container">
        <div className="row g-4">
          {contactInfo.map((item, index) => (
            <div className="col-lg-4" key={index}>
              <div
                className="contact-info-card text-center p-5"
                style={{
                  background: "#ffffff",
                  borderRadius: "25px",
                  border: "1px solid #f1f5f9",
                  boxShadow: "0 10px 30px rgba(0, 0, 0, 0.02)",
                  transition: "transform 0.3s ease",
                  height: "100%",
                }}
              >
                <div
                  className="icon-box mb-4 mx-auto d-flex align-items-center justify-content-center"
                  style={{
                    width: "80px",
                    height: "80px",
                    background: `${item.color}10`,
                    borderRadius: "20px",
                    color: item.color,
                    fontSize: "30px",
                  }}
                >
                  <i className={item.icon}></i>
                </div>
                <h4 className="fw-bold mb-3" style={{ color: "#1e293b" }}>
                  {item.title}
                </h4>
                {item.details.map((detail, idx) => (
                  <p
                    key={idx}
                    className="mb-1 text-muted"
                    style={{ fontSize: "16px" }}
                  >
                    {detail}
                  </p>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Social Media Links */}
        <style>{`
          .contact-social-btn {
            width: 54px;
            height: 54px;
            background: #f8fafc;
            border: 1px solid #e2e8f0;
            border-radius: 14px;
            color: #64748b;
            font-size: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
            text-decoration: none;
            transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
          }
          .contact-social-btn:hover {
            transform: translateY(-5px);
            box-shadow: 0 10px 25px rgba(0, 0, 0, 0.12);
            color: #fff;
          }
          .contact-social-btn.fb:hover { background: #1877F2; border-color: #1877F2; }
          .contact-social-btn.tw:hover { background: #1DA1F2; border-color: #1DA1F2; }
          .contact-social-btn.li:hover { background: #0A66C2; border-color: #0A66C2; }
          .contact-social-btn.ig:hover { background: linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888); border-color: #dc2743; }
        `}</style>
        <div className="social-links-wrapper mt-5 pt-4 text-center">
          <h5
            className="fw-bold mb-4"
            style={{
              color: "#64748b",
              textTransform: "uppercase",
              letterSpacing: "1px",
              fontSize: "14px",
            }}
          >
            Follow Our Journey
          </h5>
          <div className="d-flex justify-content-center gap-3">
            <a
              href="https://www.facebook.com/people/Xeer-Technology/61555342661387/"
              target="_blank"
              className="contact-social-btn fb"
            >
              <i className="fab fa-facebook-f"></i>
            </a>
            <a
              href="https://x.com/technology_xeer"
              target="_blank"
              className="contact-social-btn tw"
            >
              <i className="fab fa-twitter"></i>
            </a>
            <a
              href="https://www.linkedin.com/company/xeer-technology/"
              target="_blank"
              className="contact-social-btn li"
            >
              <i className="fab fa-linkedin-in"></i>
            </a>
            <a
              href="https://www.instagram.com/xeer.technology/"
              target="_blank"
              className="contact-social-btn ig"
            >
              <i className="fab fa-instagram"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactDetails;
